import { Box, Typography, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#0a0a0a',
    padding: '96px 32px',
    '@media (max-width:600px)': { padding: '64px 20px' },
  },
  inner: { maxWidth: 1280, margin: '0 auto' },
  banner: {
    background: theme.palette.primary.main,
    borderRadius: 16,
    padding: '72px 80px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 40,
    '@media (max-width:900px)': {
      padding: '40px 28px',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 24,
    },
  },
  headline: {
    fontSize: 40,
    fontWeight: 700,
    letterSpacing: '-1.5px',
    lineHeight: 1.1,
    color: '#0a0a0a',
    maxWidth: 520,
    margin: 0,
    '@media (max-width:600px)': { fontSize: 30 },
  },
  subhead: {
    fontSize: 16,
    color: 'rgba(0,0,0,0.55)',
    marginTop: 12,
    margin: 0,
  },
  cta: {
    flexShrink: 0,
    background: '#0a0a0a',
    color: '#fff',
    borderRadius: 8,
    padding: '14px 28px',
    fontSize: 15,
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': { background: '#1a1a1a', boxShadow: 'none' },
  },
}));

export default function CtaBanner() {
  const classes = useStyles();
  return (
    <Box component="section" className={classes.root}>
      <Box className={classes.inner}>
        <Box className={classes.banner}>
          <Box>
            <Typography component="h2" className={classes.headline}>
              Create content without
              <br />
              wrestling with AI.
            </Typography>
            <Typography className={classes.subhead}>
              SoriSori AI handles the complexity. You keep the creativity.
            </Typography>
          </Box>
          <Button
            className={classes.cta}
            disableElevation
            href="https://app.sorisori.ai/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Start Creating&nbsp;→
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
